<section class="edit-lesson">
  <div class="prepare-lesson">
    <div class="prepare-lesson__header"
      [routerLink]="['/teacher', 'prepare', 'new', lesson?.id]">
      <div class="prepare-lesson__header__wrapper">
        <span class="prepare-lesson__header__item__class" *ngIf="lesson">
          <ul>
            <li class="prepare-lesson__header__item__class__title">{{ lesson?.class_title }}</li>
            <li class="prepare-lesson__header__item__class__date">{{ lesson?.date | date: "dd.MM.yyyy" }}</li>
          </ul>
        </span>
        <span class="prepare-lesson__header__item__lesson-description">
          <ul>
            <li class="prepare-lesson__header__item__lesson-description__lesson-number">Занятие № {{ lesson?.lesson_number }}</li>
            <li><i><b>{{ lesson?.title }}</b></i></li>
            <li *ngIf="lesson?.remarks"><i><small>{{ lesson?.remarks }}</small></i></li>
          </ul>
        </span>
        <span class="prepare-lesson__header__item__extra-game">
          <span class="prepare-lesson__header__item__extra-game__item">
            <span><i><b>Доп. условия: </b></i> </span>
            <span *ngIf="lesson?.payment_for_task_with_cash"
              title="Оплата варианта наличными"
              class="prepare-lesson__header__item__extra-game__item__icon">
              <app-svg-icon
                [src]="armIcon"
                class="svg-icon paymentForTaskWithCash">
              </app-svg-icon>
            </span>
            <span *ngIf="lesson?.reward_with_cash"
              title="Вознаграждение наличными при работе с планшетами"
              class="prepare-lesson__header__item__extra-game__item__icon">
              <app-svg-icon
                [src]="armIcon"
                class="svg-icon rewardWithCash">
              </app-svg-icon>
            </span>
            <span *ngIf="lesson?.has_kairos_bonus"
              class="prepare-lesson__header__item__extra-game__item__icon">
              <img src="/assets/images/privilege_icons/kairos_bonus_icon.png" alt="Кайрос бонус">
            </span>
          </span>
          <span *ngIf="exExercise?.reward" class="prepare-lesson__header__item__extra-game__item">
            <span><b>Доп. задание:</b> {{ exExercise?.title }}</span>
            <span class="prepare-lesson__header__item__extra-game__item__reward"> + {{ exExercise?.reward }}</span>
          </span>
          <span *ngIf="lesson?.is_habirint"
            class="prepare-lesson__header__item__extra-game__item__icon">
            <img src="/assets/images/habirint.svg" alt="Хабиринт">
          </span>
        </span>
      </div>
    </div>
    <div class="prepare-lesson__body">
      <div class="prepare-lesson__body__preloader" *ngIf="!isBoxesLoaded">
        <div class="preloader-wrapper">
          <mat-progress-spinner
              class="spinner"
              mode="indeterminate">
          </mat-progress-spinner>
        </div>
      </div>

      <div class="prepare-lesson__body__cards" *ngIf="isBoxesLoaded">
        <div class="box__card" *ngFor="let box of lessonBoxes; let i = index">
          <app-edit-lesson-box
            [box]="box"
            [boxLevels]="lessonBoxLevels"
            [lessonID]="lesson?.id"
            [lessonDate]="lesson?.date"
            [cardIndex]="i"
            [privilegeSettings]="privilegeSettings"
            [groupRights]="groupRights"
            (cardAction)="handleCardAction($event)"
          ></app-edit-lesson-box>
        </div>
        <div class="box__card">
          <div class="box__card__new-add" (click)="addNewBox()">+</div>
        </div>
        <div class="box__card"></div>
      </div>
    </div>
    <div class="prepare-lesson__heading">
      <ul class="prepare-lesson__heading__list-button">
        <li class="prepare-lesson__heading__list-button__item">
          <button [disabled]="!checkCopyAccess()" mat-button class="small-button" (click)="openCopyDialog()">
            <mat-icon inline=true>file_copy</mat-icon>
            Копировать
          </button>
        </li>
        <li class="prepare-lesson__heading__list-button__item">
          <button mat-button class="small-button" [disabled]="!groupRights.delete_other_lesson.is_access || !groupRights.delete_templates.is_access" (click)="openRemoveDialog()">
            <mat-icon inline=true>delete</mat-icon>
            Удалить
          </button>
        </li>
        <li *ngIf="!lesson?.smart_sprints.length && !lesson?.is_online" class="prepare-lesson__heading__list-button__item">
          <button mat-raised-button class="small-button__print" [disabled]="!allowPrint" (click)="printLesson()">
            <mat-icon inline=true>layers</mat-icon>
            Печатать все
          </button>
        </li>
        <li *ngIf="lesson?.smart_sprints.length || lesson?.is_online" class="prepare-lesson__heading__list-button__item lesson-online">
          online &#9900;
        </li>
      </ul>
    </div>
  </div>
</section>

<ng-template #printNotAllowedModal>
  <div class="modal-body">
    <div class="unprepared-modal">
      <div class="row">
        <div class="col">
          <div class="unprepared-modal__title">
            Внимание.
          </div>
          <div class="unprepared-modal__title">
            Не готовы к печати варианты
          </div>
          <div class="unprepared-modal__title unprepared-modal__title_red">
            <span class="singular" *ngIf="toBeGeneratedBoxes.length === 1">бокса №</span>
            <span class="plural" *ngIf="toBeGeneratedBoxes.length > 1">боксов №</span>
            <span class="unprepared-modal__numbers">
              <span *ngFor="let box of toBeGeneratedBoxes; let isLast = last;">
                {{ box.title }}{{isLast ? '.' : ', '}}
              </span>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="unprepared-modal__actions">
            <button class=" modal__button unprepared-modal__button" (click)="modalRef.hide()">
              <i class="fa fa-refresh button-icon" aria-hidden="true"></i>
            </button>
            <div class="help-block">Подождать окончания генерации</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
